<template>
    <div id="crew-assignment-navigation">
        <div class="flex w-full justify-end items-center">
            <navigation-select menuButtonLabel="配乗表" :menuItemOptions="dailyCrewListOptions"
                @onClickItem="item => linkToOtherWindow(item.path)">
                <template slot="icon">
                    <feather-icon class="settings-icon" icon="SettingsIcon" svgClasses="h-4 w-4 mr-2" /></template>
            </navigation-select>

        </div>
    </div>
</template>
<script>
import NavigationSelect from "./NavigationSelect.vue";

export default {
    components: {
        NavigationSelect
    },
    name: "CrewAssignmentNavigation",
    data() {
        return {
            dailyCrewListOptions: [{
                name: "船舶単位",
                path: "addon-crew-assignment-management-manning-schedule-vessels",
            },
            {
                name: "船員単位",
                path: "addon-crew-assignment-management-manning-schedule-crews",
            },
            ],
        };
    },

    methods: {
        linkToOtherWindow(name) {
            const routeData = this.$router.resolve({
                name: name
            });
            window.open(routeData.href, "_blank");
        },
    },
    computed: {

    }
};
</script>
<style lang="scss" scoped>
#crew-assignment-navigation {
    position: relative;
    width: fit-content;
    margin-left: auto;
}
</style>